/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reopen_TicketInputs */

const en_admin_tickets_reopen_ticket = /** @type {(inputs: Admin_Tickets_Reopen_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen Ticket`)
};

/**
* | output |
* | --- |
* | "Reopen Ticket" |
*
* @param {Admin_Tickets_Reopen_TicketInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reopen_ticket = /** @type {((inputs?: Admin_Tickets_Reopen_TicketInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reopen_TicketInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_reopen_ticket(inputs)
});
export { admin_tickets_reopen_ticket as "admin.tickets.reopen_ticket" }